import SaleService from '@/services/sale.service'
import Utils from '@/utils'
const state = {
    page: {
        results: [],
        count: 0,
        next: null,
        previous: null
    },
    historicSales: {}
}

const getters = {}

const actions = {
    create: async ({ commit }, args) => {
        try {
            await SaleService.create(args)
            commit('createSaleSuccess')
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    },
    read: async ({ commit }, args) => {
        if (!args) args = {}
        if (!args.page) args.page = 1
        if (state.page.index == args.page) return true
        try {
            let page = await SaleService.read(args)
            commit('readSalesSuccess', page.data, args.page)
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    },
    update: async ({ commit }, args) => {
        try {
            await SaleService.update(args.id, args)
            commit('updateSaleSuccess')
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    },
    delete: async ({ commit }, { id }) => {
        try {
            await SaleService.delete(id)
            commit('deleteSaleSuccess')
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    },
    readHistoricSales: async ({ commit }, args) => {
        try {
            const page = await SaleService.readHistoricSales(args)
            commit('readHistoricSalesSuccess', { data: page.data, args: args })
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    }
}

const mutations = {
    createSaleSuccess(state) {
        // success
    },

    readSalesSuccess(state, page, page_index) {
        Utils.datetimeConverter(page.results)
        state.page = page
        state.page.index = page_index
    },

    readHistoricSalesSuccess(state, page) {
        const series = Utils.historicSalesSeriesConverter(
            page.data[0].sales,
            page.args.aggregation_type
        )
        state.historicSales = series
    },

    updateSaleSuccess(state) {
        // success
    },

    deleteSaleSuccess(state) {
        // success
    }
}

const sales = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}

export default sales
export { sales }
